import { createFileRoute } from '@tanstack/react-router';

import { CornerLanguageSelector } from '@/components/corner-language-selector';
import { PrivacyPage } from '@/components/consent/privacy-page';

export const Route = createFileRoute('/privacy')({
    component: PrivacyRoute,
});

// Local wrapper (NOT exported — route files export only Route). The switcher
// mounts here rather than inside PrivacyPage so the page component stays free
// of Clerk context requirements in unit tests.
function PrivacyRoute() {
    return (
        <>
            <CornerLanguageSelector />
            <PrivacyPage />
        </>
    );
}
